import React from 'react';
import { Box, Typography, Card, CardContent, Stack, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import usePortfolioStore from '../store/portfolioStore.js';

export default function Contact() {
  const { contacts } = usePortfolioStore();
  const waNumber = contacts.whatsapp.replace(/[^\d]/g, '');
  const waLink = `https://wa.me/${waNumber}`;

  return (
    <Box>
      <Typography variant="h5" gutterBottom>Contact</Typography>
      <Card className="glass">
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <WhatsAppIcon />
              <Button href={waLink} target="_blank" rel="noreferrer">{contacts.whatsapp}</Button>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <EmailIcon />
              <Button href={`mailto:${contacts.email}`}>{contacts.email}</Button>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <LinkedInIcon />
              <Button href={contacts.socials?.linkedin} target="_blank" rel="noreferrer">LinkedIn</Button>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <GitHubIcon />
              <Button href={contacts.socials?.github} target="_blank" rel="noreferrer">GitHub</Button>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <InstagramIcon />
              <Button href={contacts.socials?.instagram} target="_blank" rel="noreferrer">Instagram</Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
